import { EnumValue } from '@/components';
import { AnnouncementStatus } from '@/core';
import { AnnouncementState } from '@/redux';
import { Tag } from 'antd';

interface Props {
  value: Pick<AnnouncementState, 'status'>;
}

const statusColorMap: Record<AnnouncementStatus, string> = {
  Draft: 'default',
  Published: 'green',
};

export function AnnouncementStatusBadge({ value }: Props) {
  const { status } = value;

  const color = statusColorMap[status];

  return (
    <Tag color={color}>
      <EnumValue type={AnnouncementStatus} value={status} />
    </Tag>
  );
}
